<div class="minFullHeight ">
    <div class="pt-10 d-flex flex-col align-items-center" role="status">
        <mat-spinner aria-label="Preparing download" class="mx-auto" color="accent"></mat-spinner>
        <p>Preparing your memory box download. This will open in a new tab.</p>
    </div>
</div>
